import { removeDocumentInUserContext } from '../../firebase/document/documentSagas';
import { DOCTORS_PREFERENCES } from '../../../shared/collection/collectionConstants';

export default class RemoveDoctorFromFavoritesUseCase {
  static *remove(failureCallback, action) {
    yield* removeDocumentInUserContext(DOCTORS_PREFERENCES, failureCallback, action);
  }
}
